export const CURRENCIES = [
  { code: 'EUR', symbol: '€', name: 'Euro', position: 'before' },
  { code: 'USD', symbol: '$', name: 'US Dollar', position: 'before' },
  { code: 'GBP', symbol: '£', name: 'British Pound', position: 'before' },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', position: 'after' },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble', position: 'after' }
];

export const COUNTRY_CURRENCY_MAP = {
  'US': 'USD', 'CA': 'USD', 'MX': 'USD',
  'GB': 'GBP', 'UK': 'GBP',
  'CZ': 'CZK',
  'RU': 'RUB',
  'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR', 'ES': 'EUR',
  'NL': 'EUR', 'BE': 'EUR', 'AT': 'EUR', 'PT': 'EUR',
  'IE': 'EUR', 'FI': 'EUR', 'GR': 'EUR', 'PL': 'EUR',
  'default': 'EUR'
};

export const formatPrice = (amount, currencyCode) => {
  if (!amount || amount === 0) return '';

  const currency = CURRENCIES.find(c => c.code === currencyCode);
  if (!currency) return `${amount} ${currencyCode}`;

  // Format number with proper separators
  const formattedAmount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);

  if (currency.position === 'before') {
    return `${currency.symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount} ${currency.symbol}`;
  }
};

export const detectAndSetUserCurrency = async (userId, db, firestoreDoc, firestoreSetDoc) => {
  try {
    // Try IP-based detection
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    const country = data.country_code;
    const currency = COUNTRY_CURRENCY_MAP[country] || 'EUR';

    const userRef = firestoreDoc(db, 'users', userId);
    await firestoreSetDoc(userRef, {
      preferredCurrency: currency,
      detectedCountry: country,
      detectedAt: new Date()
    }, { merge: true });

    return currency;
  } catch (error) {
    console.error('Currency detection failed:', error);
    // Fallback to EUR
    const userRef = firestoreDoc(db, 'users', userId);
    await firestoreSetDoc(userRef, {
      preferredCurrency: 'EUR',
      detectedCountry: null,
      detectedAt: new Date()
    }, { merge: true });

    return 'EUR';
  }
};

export const getCurrencySymbol = (currencyCode) => {
  const currency = CURRENCIES.find(c => c.code === currencyCode);
  return currency ? currency.symbol : currencyCode;
};
